import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=82091946&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-content.scss?vue&type=style&index=0&id=82091946&scoped=true&lang=scss&"
import style1 from "@/sass/07_elements/content-box.scss?vue&type=style&index=1&id=82091946&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82091946",
  null
  
)

export default component.exports